import React from 'react';

function Field({ label, hint, children }) {
  return (
    <div>
      <label className="text-sm font-medium text-gray-800">{label}</label>
      {hint ? <div className="text-xs text-gray-500 mt-1">{hint}</div> : null}
      <div className="mt-2">{children}</div>
    </div>
  );
}

export default function RodapeForm({ value = {}, onChange }) {
  const v = value || {};
  const set = (patch) => onChange?.(patch);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <Field label="Texto curto (sobre)" hint="Aparece no rodapé à esquerda">
        <textarea
          value={v.texto || ''}
          onChange={(e) => set({ texto: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-200 min-h-[110px]"
          placeholder="Corretor de imóveis especializado em..."
        />
      </Field>

      <Field label="CRECI no rodapé (opcional)" hint="Ex: 123456-F/SP">
        <input
          value={v.creci || ''}
          onChange={(e) => set({ creci: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-200"
          placeholder="CRECI: 123456-F/UF"
        />
      </Field>

      <Field label="Texto de copyright (opcional)">
        <input
          value={v.copyright || ''}
          onChange={(e) => set({ copyright: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-200"
          placeholder="© 2026 Seu Nome. Todos os direitos reservados."
        />
      </Field>

      <Field
        label="Links institucionais (opcional)"
        hint="Ex: Política de Privacidade | Termos de Uso"
      >
        <input
          value={v.linksLegais || ''}
          onChange={(e) => set({ linksLegais: e.target.value })}
          className="w-full px-3 py-2 rounded-lg border border-gray-200"
          placeholder="Política de Privacidade | Termos de Uso"
        />
      </Field>

      <div className="md:col-span-2 rounded-xl border border-gray-200 p-4">
        <div className="font-semibold text-gray-900 mb-1">Mostrar redes</div>
        <div className="text-sm text-gray-500">
          As URLs já vêm da aba “Contatos & Redes”, aqui é só pra
          exibir/ocultar.
        </div>

        <div className="mt-3 flex items-center gap-2">
          <input
            id="showSocial"
            type="checkbox"
            checked={v.showSocial !== false}
            onChange={(e) => set({ showSocial: e.target.checked })}
            className="h-4 w-4"
          />
          <label htmlFor="showSocial" className="text-sm text-gray-800">
            Exibir ícones de redes sociais no rodapé
          </label>
        </div>
      </div>
    </div>
  );
}
